import {useCallback} from 'react'
import {useTranslation} from 'next-i18next'
import AppButton from 'src/components/elements/buttons/AppButton'
import AppModal from 'src/components/elements/AppModal'
import AppDivider from 'src/components/elements/AppDivider'
import SocialLogin from 'src/components/modules/dialog/SocialLogin'
import {ModalType} from 'src/types/modal'
import {useRedirectContext} from 'src/context/RedirectProvider'
import AppTypography from 'src/components/elements/typography/AppTypography'

export default function QuestionDialog(props: {
  open: boolean
  onClose: () => void
  setModal: React.Dispatch<React.SetStateAction<ModalType>>
}) {
  const {open, onClose, setModal} = props

  const {clearRedirect} = useRedirectContext()
  const {t} = useTranslation('auth')

  const handleClose = useCallback(() => {
    clearRedirect()
    onClose()
  }, [clearRedirect, onClose])

  return (
    <AppModal
      size="small"
      open={open}
      title={t('welcome')}
      onClose={handleClose}
    >
      <AppButton
        variant="contained"
        color="primary"
        onClick={() => setModal('signup')}
        fullWidth
        type="submit"
        id="sign_up_by_email"
      >
        {t('create_an_account')}
      </AppButton>
      <AppButton
        variant="contained"
        fullWidth
        type="submit"
        onClick={() => setModal('signin')}
        style={{
          marginTop: 20,
        }}
      >
        {t('continue_with_email')}
      </AppButton>
      <AppDivider className="mt-9" />
      <AppTypography
        variant="caption"
        className="text-text-secondary text-center py-1"
      >
        {t('or_continue_with')}
      </AppTypography>
      <AppDivider className="mb-9" />
      <SocialLogin />
    </AppModal>
  )
}
